if ( typeof PickupAvailabilityCompact !== 'function' ) {

  class PickupAvailabilityCompact extends HTMLElement {

    constructor(){

      super();
      this.classList.add('active');

      const widgetIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);
        this.fetchAvailability(this.dataset.variantId);
      }
      new IntersectionObserver(widgetIntersection.bind(this), {rootMargin: '0px 0px 50px 0px'}).observe(this);

      this.storeSelector = document.querySelector('store-selector[data-main-selector]');
      window.addEventListener('load', ()=>{
        if ( this.storeSelector ) {
          this.storeSelector.addEventListener('storechanged', e=>{
            this.fetchAvailability(this.dataset.variantId);
          })
        }
      })
      
    }

    fetchAvailability(variantId) {

      const sectionId = this.dataset.sectionId || 'helper-pickup-availability-compact';
      let variantSectionUrl = `${this.dataset.baseUrl}/variants/${variantId}/?section_id=${sectionId}`;
      if ( this.dataset.productUrl ) {
        const productUrl = new URL(this.dataset.productUrl, this.dataset.baseUrl);
        productUrl.searchParams.set('section_id', sectionId);
        if ( variantId ) {
          productUrl.searchParams.set('variant', variantId);
        }
        variantSectionUrl = productUrl.toString();
      }

      fetch(variantSectionUrl)
        .then(response => {
          if ( !response.ok ) {
            throw new Error(response.status);
          }
          return response.text();
        })
        .then(text => {
          const doc = new DOMParser().parseFromString(text, 'text/html');
          const sectionInnerHTML = doc.querySelector('.shopify-section') || doc.body;
          if ( sectionInnerHTML ) {
            this.renderPreview(sectionInnerHTML);
          }
        })
        .catch(e => {
          console.log(e);
        });

    }
    
    renderPreview(sectionInnerHTML) {
      
      const selectedStore = localStorage.getItem('selected-store');
      const storeAlerts = sectionInnerHTML.querySelectorAll('.pickup-availability-alert[data-store]');
      const singleStore = storeAlerts.length === 1;

      if ( this.storeSelector && selectedStore && this.storeSelector.storesList[selectedStore] ) {
        // search based on selected store 
        let storeFound = false;
        if ( selectedStore ) {
          storeAlerts.forEach(elm=>{
            if ( selectedStore == elm.dataset.store ) {
              this.innerHTML = elm.innerHTML.replace('{{ store }}', this.storeSelector.storesList[selectedStore]);
              storeFound = true;
            }
          })
        }
        if ( !storeFound && singleStore ) {
          this.innerHTML = storeAlerts[0].innerHTML.replace('{{ store }}', this.storeSelector.storesList[selectedStore]);
          storeFound = true;
        }
        if ( !storeFound ) {
          this.innerHTML = sectionInnerHTML.querySelector('.pickup-availability-alert[data-default-unavailable]').innerHTML.replace('{{ store }}', this.storeSelector.storesList[selectedStore]);
          storeFound = true;
        }
        if ( !selectedStore || !storeFound ) {
          this.innerHTML = '';
        }
      } else {
        // search based on default store
        this.innerHTML = sectionInnerHTML.querySelector('.pickup-availability-alert[data-default-store]').innerHTML;
      }

    }
    
  }

  if ( typeof customElements.get('pickup-availability-compact') == 'undefined' ) {
    customElements.define('pickup-availability-compact', PickupAvailabilityCompact);
	}

}

if ( typeof PickupAvailabilityExtended !== 'function' ) {

  class PickupAvailabilityExtended extends HTMLElement {

    constructor() {
      super();
      this.classList.add('active');
      this.fetchAvailability(this.dataset.variantId);
    }


    fetchAvailability(variantId) {

      const sectionId = this.dataset.sectionId || 'helper-pickup-availability-extended';
      let variantSectionUrl = `${this.dataset.baseUrl}/variants/${variantId}/?section_id=${sectionId}`;
      if ( this.dataset.productUrl ) {
        const productUrl = new URL(this.dataset.productUrl, this.dataset.baseUrl);
        productUrl.searchParams.set('section_id', sectionId);
        if ( variantId ) {
          productUrl.searchParams.set('variant', variantId);
        }
        variantSectionUrl = productUrl.toString();
      }

      fetch(variantSectionUrl)
        .then(response => {
          if ( !response.ok ) {
            throw new Error(response.status);
          }
          return response.text();
        })
        .then(text => {
          const doc = new DOMParser().parseFromString(text, 'text/html');
          const sectionInnerHTML = doc.querySelector('.shopify-section') || doc.body;
          if ( sectionInnerHTML ) {
            this.renderPreview(sectionInnerHTML);
          }
        })
        .catch(e => {
          console.log(e);
        });

    }

    renderPreview(sectionInnerHTML) {
      const availabilityWidget = sectionInnerHTML.querySelector('#PickupAvailabilityWidget');
      if ( availabilityWidget ) {
        this.innerHTML = availabilityWidget.innerHTML;
        this.querySelectorAll('.pickup-availability-widget__location-view').forEach(elm=>{
          elm.addEventListener('click', ()=>{
            document.getElementById(`${elm.getAttribute('aria-controls')}`).classList.toggle('opened');
            elm.setAttribute('aria-selected', elm.getAttribute('aria-selected') == "true" ? "false" : "true");
          })
        })
      } else {
        console.log('error in availablity fetch');
      }

      const availabilitySidebar = sectionInnerHTML.querySelector('#PickupAvailabilitySidebar');
      if ( availabilitySidebar ) {
        if ( document.querySelector('sidebar-drawer#site-availability-sidebar') ) {
          document.querySelector('sidebar-drawer#site-availability-sidebar').remove();
        } 
        document.body.appendChild(availabilitySidebar.querySelector('#site-availability-sidebar'));
        document.querySelector('.pickup-availability-widget__more').addEventListener('click', e=>{
          e.preventDefault();
          document.getElementById('site-availability-sidebar').show();
        })
      }

    }

  }

  if ( typeof customElements.get('pickup-availability-extended') == 'undefined' ) {
    customElements.define('pickup-availability-extended', PickupAvailabilityExtended);
	}

}
